import { render } from "./quick-module.vue?vue&type=template&id=afca389e&scoped=true"
import script from "./quick-module.vue?vue&type=script&lang=js"
export * from "./quick-module.vue?vue&type=script&lang=js"

import "./quick-module.vue?vue&type=style&index=0&id=afca389e&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afca389e"]])

export default __exports__